module.exports = __webpack_public_path__ + "img/user.33c94a90.png";